import _get from "lodash/get";
// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { ApplyNowLink } from '@nerdwallet/react-apply-now';
import Image from '@nerdwallet/react-image'; // Utils

import classnames from 'classnames';
var BLANK_IMAGE_SRC = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='; // Component

var ProductImage = function ProductImage(_ref) {
  var data = _ref.data,
      className = _ref.className,
      config = _ref.config;

  var productSlug = _get(data, config.cc_slug || config.provider_key);

  var src = _get(data, config.data_keys[0], BLANK_IMAGE_SRC);

  var linkConfig = _get(data, config.link_data_key);

  var offerVersionId = config.offerVersionId ? _get(data, config.offerVersionId) : null;

  var isCC = _get(config, 'is_cc', false);

  var productId = _get(data, config.provider_id);

  var classes = classnames(className, config.className, 'product-image', {
    'product-image-portrait': false,
    'product-image-landscape': true
  });
  return React.createElement("div", {
    className: "product-image-wrapper"
  }, React.createElement(ApplyNowLink, {
    isCC: isCC,
    id: "".concat(productId, "-logo"),
    link: linkConfig,
    linkType: config.link_type,
    finishType: config.finish_type,
    monetizable: config.monetizable,
    offerVersionId: offerVersionId,
    productId: productId,
    productSlug: productSlug,
    vertical: config.product_topic
  }, React.createElement(Image, {
    className: classes,
    src: src,
    alt: productSlug,
    backgroundColor: "transparent",
    objectFit: "contain"
  })));
};

ProductImage.displayName = 'ProductImage';
ProductImage.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
  config: PropTypes.object
  /**
  * Any further props will be passed to the <img>!
  */

};
export default ProductImage;